import React from "react";
import PropTypes from "prop-types";

export default function CardContentButtons({ buttons, fullWidth = true }) {
  return (
    <div className="slds-grid" style={{gap: "12px"}}>
      {buttons.map((btn, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} style={fullWidth ? {width: "100%"} : undefined}>
          {btn}
        </div>
      ))}
    </div>
  );
}

const { arrayOf, bool, node } = PropTypes;

CardContentButtons.propTypes = {
  buttons: arrayOf(node).isRequired,
  fullWidth: bool
};
